/**
 * Generates the session ID that can be used as a correlation ID.
 *
 * Formula:
 * 1. Prepend the current base-36 encoded UNIX timestamp with a random base-36 encoded number of most 3 digits.
 * 2. Replace 1-9 in the resulting base-36 representation with A-J
 */
export default function generateSessionId(): string {
  const capitalAOffset = 65;
  const randomSeed = Math.floor(Math.random() * 1000).toString(36); // NOSONAR
  const sessionId = randomSeed + Date.now().toString(36);

  return sessionId
    .split('')
    .map((sessionIdChar: string) => {
      const parsedInt = parseInt(sessionIdChar, 10);
      return isNaN(parsedInt) ? sessionIdChar : String.fromCharCode(parsedInt + capitalAOffset);
    })
    .join('');
}
